module.exports = __webpack_public_path__ + "img/carrot.53ed0632.gif";